import { isString } from "./utils";

export class HtmlManager {
    #containerDiv: HTMLElement;
    constructor(container: HTMLElement | string) {
        let t = document.getElementById("ncDataTable");
        if (t !== null) {

            return;
        }
        else {
            if (isString(container)) {
                let c = document.querySelector(container) as HTMLElement;
                if (c === null || c === undefined) {
                    console.error("Cannot find element.");
                }
                else {
                    this.#containerDiv = c;
                }
            }
            else {
                this.#containerDiv = container;
            }
            this.#containerDiv.innerHTML = this.#html;
        }
    }

    #dataTable: HTMLTableElement;
    getDataTable() {
        if (this.#dataTable === null || this.#dataTable === undefined) {
            this.#dataTable = <HTMLTableElement>(document.getElementById("ncDataTable"));
        }
        return this.#dataTable;
    }


    #html = `        <div
    style=" display: flex; flex-direction: column; position: absolute; right: 10px; z-index: 100; bottom: 2px;">
    <button id="ncUndo" class="btn btn-primary nctd-btn-md m-1 float-right ">
        <div class="undoSVG"></div>
    </button>
    <button id="ncRedo" class="btn btn-primary nctd-btn-md m-1 float-right">
        <div class="redoSVG"></div>
    </button>
    <button id="ncZoomToFit" class="btn btn-primary nctd-btn-md m-1">
        <div class="zoomToFitSVG"></div>
    </button>
    <button id="ncStartStopDrawing" style="display: none;" class="btn nctd-btn-md btn-primary m-1"
        type="button">
        Start Drawing
    </button>
</div>

<div class="" style="display: flex; flex-grow: 1;">

    <div id="dataGrid"
        style=" display: flex; flex-direction: column; padding: 10px; min-width: 25px; width: 220px; overflow:auto;"
        class="nctd-dataGrid">
        <button id="showHideSettings" class="btn btn-sm nctd-btn-sm btn-secondary"
            style="display:flex; flex-shrink: 0;  align-content: center; background-color: rgb(121, 120, 120);"
            type="button">
            Show Settings
        </button>

        <div id="trimDesignerSettings" class="rounded"
            style="display: none; padding: 8px; border-style: solid; border-width: 2px; border-color: rgba(92, 19, 19, 0.678); background-color: #f7f7f7;">
            <div class="form-check-inline">
                <input id="nctdProfileOnly" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdProfileOnly" class="form-check-label">Profile Only</label>
            </div>
            <div class="form-inline">
                <input id="nctdSnap" class="form-check-input" type="checkbox" checked="true" />
                <label class="form-check-label" for="nctdSnap">Snap Precision</label>
                <input id="nctdSnapPrecision" type="number" value="5"
                    class="form-control form-control-sm nctd-form-control-sm ml-1"
                    style="min-width:40px; max-width: 80px;" />
            </div>
            <div class="form-inline">
                <input id="nctdShowPoint" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdShowPoint" class="form-check-label">Point Size</label>
                <input id="nctdPointSize" class="form-control form-control-sm ml-1"
                    style="min-width: 40px;max-width: 80px;" type="number" value="10" />
            </div>
            <div class="form-inline">
                <input id="nctdShowPaintIndicator" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdShowPaintIndicator" class="form-check-label">Show Paint Indicator</label>
            </div>
            <div class="form-inline">
                <input id="nctdShowAngleLabelsUnder" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdShowAngleLabelsUnder" class="form-check-label">Show Angle Labels Under</label>
                <input id="nctdAngleLabelLimit" class="form-control form-control-sm nctd-form-control-sm ml-1"
                    type="number" value="180" style="min-width: 40px;max-width: 80px; " />
            </div>
            <div class="form-inline">
                <input id="nctdShowLengthLabels" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdShowLengthLabels" class="form-check-label">Show Length Labels Over</label>
                <input id="nctdLengthLabelLimit" class="form-control form-control-sm nctd-form-control-sm ml-1"
                    type="number" value="0" min="0" style="min-width: 40px;max-width: 80px; " />
            </div>
            <div class="form-inline">
                <label class="">Bend Radius Inches</label>
                <input id="nctdBendRadius" class="form-control form-control-sm nctd-form-control-sm ml-1"
                    type="number" step=".001" min=".001" max=".5" inputmode="numeric" value="0.047" step="0.001"
                    style="min-width: 60px;" />
            </div>
            <div>
                <input id="nctdGrayBackground" type="color" value="#808080" />
                <label for="nctdGrayBackground">Background Color</label>
            </div>
            <div>
                <button id='nctdResetSettings' class="btn btn-secondary btn-sm nctd-btn-sm btn-block"
                    style="background-color: rgb(202, 81, 81);">Reset
                    Settings</button>
            </div>
        </div>


        <div
            style=" display: flex; flex-shrink: 0; flex-direction: column; padding: 5px; margin-top:5px;background-color: lightgray; border-radius: 5px;  border: 2px solid black;">
            <div style="display: flex; flex-shrink: 0;" id="nctdDescriptionLabel">Description</div>
            <div style="display: flex; flex-shrink: 0;" id="nctdPriceLabel">Price: 6.07</div>
            <div style="display: flex; flex-shrink: 0;" id="nctdBlankWidthLabel">Blank width: 8-3/4"</div>

        </div>
        <div
            style="display: flex; flex-shrink: 0; align-content: flex-end; align-items:center; justify-content: center;">
            <button id="nctdCalculateTrimPrice" class="btn btn-primary btn-sm nctd-btn-sm" style="margin: 2px;"
                type="button">Calculate
                Price</button>
        </div>


        <div id="nctdDescriptionOptions" class="rounded"
            style="display: flex; flex-shrink: 0; flex-direction: column; padding:4px; border-style: solid; border-width: 2px; border-color: rgba(19, 30, 92, 0.678); margin-top: 2px;">

            <div class="">
                <label style="text-align: center; margin-bottom: -2px;">Description</label>
                <input id="nctdDescriptionInput" class="form-control form-control-sm nctd-form-control-sm"
                    type="text" />
            </div>
            <div class="form-inline">
                <input id="nctdIncludeLength" class="form-check-input" type="checkbox" checked="true" />
                <label for="nctdIncludeLength" class="form-check-label">Include Length</label>
            </div>
            <div class="form-inline">
                <input id="nctdIncludeCoilDescription" class="form-check-input" type="checkbox"
                    checked="false" />
                <label for="nctdIncludeCoilDescription" class="form-check-label">Include Coil
                    Description</label>
            </div>
            <div class="form-inline">
                <input id="nctdIncludeColorDescription" class="form-check-input" type="checkbox"
                    checked="false" />
                <label for="nctdIncludeColorDescription" class="form-check-label">Include Color
                    Description</label>
            </div>
        </div>

        <div id="ncTrimOptions" style="padding: 4px;">
            <div class="form-inline">
                <label style="min-width: 45px;">Length</label>
                <input id="nctdLength" class="form-control form-control-sm nctd-form-control-sm ml-1"
                    style="max-width: 150px;" />
            </div>
            <div class="form-inline">
                <label style="min-width: 45px;">Coil</label>
                <select id="nctdCoil" class="form-control form-control-sm nctd-form-control-sm ml-2">
                </select>
            </div>
            <div class="form-inline">
                <label style="min-width: 45px;">Color</label>
                <select id="nctdColor" class="form-control form-control-sm nctd-form-control-sm ml-2"
                    style="min-width: 100px;">
                </select>
            </div>


            <div class=" form-group form-inline custom-control custom-switch">
                <input id="nctdReversePaintSide" type="checkbox" checked="true" class="custom-control-input" />
                <label for="nctdReversePaintSide" class="custom-control-label"
                    style="display: inline-block;">Reverse Painted Side</label>
            </div>
        </div>
        <div id="ncDataTableDiv" style="flex-grow: 1; min-height: 150px;">
            <table id="ncDataTable"
                class="table table-sm nctd-table-sm table-borderless table-striped flex-grow-1 flex-fill"
                style="width: fit-content;">
                <thead>
                    <tr>
                        <td></td>
                        <td>Length</td>
                        <td>Angle</td>
                    </tr>
                </thead>
                <tbody>
                    <template id="rowTemplate">
                        <td class="segmentIdx"></td>
                        <td>
                            <input style="min-width: 50px;" inputmode="numeric"
                                class="form-control form-control-sm  nctd-form-control-sm length" value="" />
                        </td>
                        <td>
                            <input style="min-width: 50px;" inputmode="numeric"
                                class="form-control form-control-sm nctd-form-control-sm angle" value="" />
                        </td>
                        <td>
                            <button class="btn btn-secondary btn-sm nctd-btn-sm btnremovePoint"
                                style="margin: 0px;">
                                X
                            </button>
                        </td>
                    </template>
                </tbody>
            </table>
        </div>
    </div>

    <!-- <div id="separator" class="nctd-separator"></div> -->
    <div id="drawing" class="flex-group-1 flex-fill nctd-drawing"></div>

</div>`;
}